import { IFlashcard, IGenerateFlashcardWithAI } from '@sdk/contracts';
import { create as createStore } from 'zustand';

interface IStore {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  isOpenGenerateFlashcardWithAI: boolean;
  setIsOpenGenerateFlashcardWithAI: (isOpen: boolean) => void;
  isOpenGeneratingFlashcardWithAI: boolean;
  setIsOpenGeneratingFlashcardWithAI: (isOpen: boolean) => void;
  flashcardForm: Partial<IFlashcard> | null;
  setFlashcardForm: (form: Partial<IFlashcard> | null) => void;
  flashcardWithAIForm: Partial<IGenerateFlashcardWithAI> | null;
  setFlashcardWithAIForm: (form: Partial<IGenerateFlashcardWithAI> | null) => void;
}

export const useFlashcardForm = createStore<IStore>(set => ({
  isOpen: false,
  setIsOpen: (isOpen: boolean) => {
    set({ isOpen });
  },
  isOpenGenerateFlashcardWithAI: false,
  setIsOpenGenerateFlashcardWithAI: (isOpen: boolean) => {
    set({ isOpenGenerateFlashcardWithAI: isOpen });
  },
  flashcardForm: null,
  setFlashcardForm: (form: Partial<IFlashcard> | null) => {
    set({ flashcardForm: form });
  },
  flashcardWithAIForm: null,
  setFlashcardWithAIForm: (form: Partial<IGenerateFlashcardWithAI> | null) => {
    set({ flashcardWithAIForm: form });
  },
  isOpenGeneratingFlashcardWithAI: false,
  setIsOpenGeneratingFlashcardWithAI: (isOpen: boolean) => {
    set({ isOpenGeneratingFlashcardWithAI: isOpen });
  }
}));
